
import React, { forwardRef, useImperativeHandle, useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../../scss/popup.scss";
import { isValidEmail } from '../../utils/utils';
import CustomPopup from './custom-popup';
import Form from 'react-bootstrap/Form';
import PropTypes from "prop-types";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const WebinarRegistrationPopup = forwardRef((props, ref) => {
    console.log('props ', props)
    const captchaRef = useRef(null);
    const [show, setShow] = React.useState(false);
    const [isSending, setIsSending] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [regisLink, setRegisLink] = useState('');
    const popupCloseHandler = (e) => {
        setShow(false);
    };
    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        close() {
            setShow(false);
        },

        open(link = '') {
            if (link) {
                setRegisLink(link);
            }
            setShow(true);
        }
    }));

    const submit = async (e) => {
        if (!fullName || !isValidEmail(email)) {
            alert('Please input valid information');
            return;
        }

        const token = captchaRef.current.getValue();
        if (!token) {
            alert("Please Confirm You Are Not a Robot!");
            return;
        }

        setIsSending(true);

        // Call API to save info
        const data = {
            recaptchaToken: token,
            email: email,
            name: fullName,
            phone: '',
            subject: `[Inventiv] [${fullName}, ${email}] Webinar Registration`,
            message: `${fullName} has registered for the webinar with the email ${email}. ${props.title ? `Webinar Title: ${props.title}` : ''}`,
            site: 'inventiv.org'
        }

        console.log('data to submit ', data);
        // Add to our database
        fetch("https://api.trustyip.com/subcribers/add", {
            "method": "POST",
            "headers": {
                "content-type": "application/json",
                "accept": "application/json"
            },
            "body": JSON.stringify(data)
        })
            .then(response => response.json())
            .then(response => {
                // reset
                setEmail('');
                setFullName('');
                //
                console.log(regisLink + `&email=${email}&first_name=${fullName}`)
                document.location.href = regisLink + `&email=${email}&first_name=${fullName}`;
            })
            .catch(err => {
                alert('There is something wrong. Please try again later!');
                console.log(err);
            }).finally(() => {
                setIsSending(false);
            });

    }

    return (
        <>
            <CustomPopup
                onClose={popupCloseHandler}
                show={show}
                title="">
                {
                    showForm ?
                        <div>
                            <h5 className="text-center fw-bold mb-4">Please provide your contact information</h5>
                            <Form >
                                <Form.Group className="mb-1" controlId="formBasicName">
                                    <Form.Control type="text" placeholder="Full name" required="true" value={fullName} onChange={e => setFullName(e.target.value)} />
                                </Form.Group>

                                <Form.Group className="mb-2" controlId="formBasicEmail">
                                    <Form.Control type="email" placeholder="Your email" required="true" value={email} onChange={e => setEmail(e.target.value)} />
                                </Form.Group>

                                <Form.Group className="mb-2">
                                    <ReCAPTCHA
                                        sitekey={process.env.RECAPTCHA_SITE_KEY}
                                        ref={captchaRef}
                                    />
                                </Form.Group>

                                <button type="button" className={`btn btn-warning w-100 ${isSending ? 'disabled' : ''}`} onClick={submit}>Submit</button>
                            </Form>
                        </div>
                        :
                        <div class="_form-thank-you">
                            <h3 className='text-center'>Thank you!</h3>
                            <p className='text-center'>
                                Thank you for contacting us. We will follow up with you soon
                            </p>
                            <p className='text-center'>Inventiv.org.</p>
                        </div>
                }
            </CustomPopup>
        </>
    )
});

// Define props for the component
WebinarRegistrationPopup.defaultProps = {
    title: ''
};

WebinarRegistrationPopup.propTypes = {
    title: PropTypes.string
};

export default WebinarRegistrationPopup;
